var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveMointer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_212_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 3.68629 4.68629 1 8 1H36C39.3137 1 42 3.68629 42 7V35C42 38.3137 39.3137 41 36 41H8C4.68629 41 2 38.3137 2 35V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5H36C39.0376 1.5 41.5 3.96243 41.5 7V35C41.5 38.0376 39.0376 40.5 36 40.5H8C4.96243 40.5 2.5 38.0376 2.5 35V7C2.5 3.96243 4.96243 1.5 8 1.5Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22.5531 12 23 12.4469 23 13V15H26.75C27.9937 15 29 16.0062 29 17.25V25.75C29 26.9937 27.9937 28 26.75 28H17.25C16.0062 28 15 26.9937 15 25.75V17.25C15 16.0062 16.0062 15 17.25 15H21V13C21 12.4469 21.4469 12 22 12ZM18.5 24C18.225 24 18 24.225 18 24.5C18 24.775 18.225 25 18.5 25H19.5C19.775 25 20 24.775 20 24.5C20 24.225 19.775 24 19.5 24H18.5ZM21.5 24C21.225 24 21 24.225 21 24.5C21 24.775 21.225 25 21.5 25H22.5C22.775 25 23 24.775 23 24.5C23 24.225 22.775 24 22.5 24H21.5ZM24.5 24C24.225 24 24 24.225 24 24.5C24 24.775 24.225 25 24.5 25H25.5C25.775 25 26 24.775 26 24.5C26 24.225 25.775 24 25.5 24H24.5ZM20.25 20C20.25 19.6685 20.1183 19.3505 19.8839 19.1161C19.6495 18.8817 19.3315 18.75 19 18.75C18.6685 18.75 18.3505 18.8817 18.1161 19.1161C17.8817 19.3505 17.75 19.6685 17.75 20C17.75 20.3315 17.8817 20.6495 18.1161 20.8839C18.3505 21.1183 18.6685 21.25 19 21.25C19.3315 21.25 19.6495 21.1183 19.8839 20.8839C20.1183 20.6495 20.25 20.3315 20.25 20ZM25 21.25C25.3315 21.25 25.6495 21.1183 25.8839 20.8839C26.1183 20.6495 26.25 20.3315 26.25 20C26.25 19.6685 26.1183 19.3505 25.8839 19.1161C25.6495 18.8817 25.3315 18.75 25 18.75C24.6685 18.75 24.3505 18.8817 24.1161 19.1161C23.8817 19.3505 23.75 19.6685 23.75 20C23.75 20.3315 23.8817 20.6495 24.1161 20.8839C24.3505 21.1183 24.6685 21.25 25 21.25ZM13.5 19H14V25H13.5C12.6719 25 12 24.3281 12 23.5V20.5C12 19.6719 12.6719 19 13.5 19ZM30.5 19C31.3281 19 32 19.6719 32 20.5V23.5C32 24.3281 31.3281 25 30.5 25H30V19H30.5Z",
    fill: "#092E5E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_212_1141",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_1141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_1141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_1141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveMointer);
export default __webpack_public_path__ + "static/media/ic_active_mointer.836fa1b4fe019a66a1d2cf5958f86715.svg";
export { ForwardRef as ReactComponent };